export default {
  SET_SECTORS(state, sectors) {
    state.sectors = sectors;
  },

  SET_SECTOR(state, updatedSector) {
    const index = state.sectors.collection.findIndex((s) => s.id === updatedSector.id);
    if (index !== -1) {
      state.sectors.collection.splice(index, 1, updatedSector);
    }
  },

  ADD_SECTOR(state, sector) {
    state.sectors.collection.unshift(sector);
  },

  DELETE_SECTOR(state, id) {
    const index = state.sectors.collection.findIndex((s) => s.id === id);
    if (index >= 0) {
      state.sectors.collection.splice(index, 1);
    }
  },

  SET_CURRENT_SECTOR(state, sector) {
    state.currentSector = sector;
  },

  SET_SECTOR_LIST(state, sectors) {
    state.sectorList = sectors;
  },

  SET_AGENCIES(state, { parent, agencies }) {
    this._vm.$set(state.agencies, parent, agencies);
  },

  REMOVE_AGENCIES(state, { parent }) {
    this._vm.$delete(state.agencies, parent);
  },

  RESET_OPEN_AGENCIES(state) {
    state.agencies = {};
  },

  SET_AGENCY(state, updatedAgency) {
    const parent = updatedAgency.metadata.sectorId;
    const sectorAgencies = state.agencies[parent];
    if (sectorAgencies) {
      const index = sectorAgencies.collection.findIndex((a) => a.id === updatedAgency.id);
      if (index >= 0) {
        sectorAgencies.collection.splice(index, 1, updatedAgency);
      }
    }
  },

  ADD_AGENCY(state, agency) {
    const parent = agency.metadata.sectorId;
    const sectorAgencies = state.agencies[parent];
    if (sectorAgencies) {
      sectorAgencies.collection.unshift(agency);
    }
    const sectorIndex = state.sectors.collection.findIndex((s) => s.id === parent);
    if (sectorIndex >= 0) {
      state.sectors.collection[sectorIndex].count++;
    }
  },

  DELETE_AGENCY(state, { agencyId, sectorId }) {
    const sectorAgencies = state.agencies[sectorId];
    if (!sectorAgencies) return;

    const index = sectorAgencies.collection.findIndex((a) => a.id === agencyId);
    if (index !== -1) {
      const agencySectorId = sectorAgencies.collection[index].metadata.sectorId;
      sectorAgencies.collection.splice(index, 1);

      const sectorIndex = state.sectors.collection.findIndex((s) => s.id === agencySectorId);
      if (sectorIndex >= 0) {
        state.sectors.collection[sectorIndex].count--;
      }
    }
  },

  SET_CURRENT_AGENCY(state, agency) {
    state.currentAgency = agency;
  },

  SET_AGENCY_LIST(state, agencies) {
    state.agencyList = agencies;
  },

  SET_INSTANCE_ID(state, instanceId) {
    state.instanceId = instanceId;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_FORM_BACKEND_VALIDATED(state, value) {
    state.isFormBackendValidated = value;
  },

  SET_EDITING_AGENCY_VACCINE_EXCEPTION(state, exception) {
    state.editingAgencyVaccineException = exception;
  },
};
